import { useAppSelector } from '@ui/app/store';
import { AppMode } from '@ui/constants';
import { selectAppMode } from '@ui/store/slices/userSlice';

export const useAppMode = (): AppMode => useAppSelector(state => selectAppMode(state));
